// The Gantt's "Today", "Created today" and "Due today" filters, and what
// the chart says when a filter leaves nothing to draw.
//
// Days are compared as 'YYYY-MM-DD' keys (helpers/dateRange): start and end
// dates are DATE-ONLY (midnight UTC of the day picked) so they are read
// with UTC accessors; createdAt is an INSTANT, read in the reader's day.
// Reading an end date with local accessors put every due date a day early
// west of UTC - an activity due tomorrow showed under "Due today".
import { utcDayKey, localDayKey } from "helpers/dateRange";

export const todayKey = (now = new Date()) => localDayKey(now);

/** Running today (started on or before today) or overdue, not done. */
export const runsToday = (it, today = todayKey()) => {
  const st = utcDayKey(it.startDate);
  return !!st && it.status !== "done" && st <= today;
};

/** Added today, in the reader's day. */
export const madeToday = (it, today = todayKey()) => !!it.createdAt && localDayKey(it.createdAt) === today;

/** Ending today, or past its end and not done - the Issues page's "Due today". */
export const dueTodayItem = (it, today = todayKey()) => {
  const en = utcDayKey(it.endDate || it.startDate);
  return !!en && it.status !== "done" && en <= today;
};

/**
 * The line shown when there are no rows. A schedule that HAS activities is
 * never told to build one: a filter that matches nothing says which filter.
 * -> null when there are rows to draw.
 */
export function emptyMessage({ total, shown, query, todayFilter, createdToday, dueToday, dated, owner = "" }) {
  if (shown > 0) return null;
  if (!total) return "No schedule yet — build the schedule first.";
  const active = [query && "search", todayFilter && "today", createdToday && "created", dueToday && "due", dated && "dates", owner && "owner"].filter(Boolean);
  if (active.length > 1) return `No activities match these filters (${total} in the schedule).`;
  if (query) return `No activities match "${query}".`;
  if (dueToday) return "Nothing is due today or overdue.";
  if (createdToday) return "No activities were added today.";
  if (todayFilter) return "Nothing is running today.";
  if (owner) return `No activities in that owner/GC sign-off state (${total} in the schedule).`;
  return `No activities in these dates (${total} in the schedule).`;
}

// THE OWNER/GC SIGN-OFF FILTER (owner, 2026-10-21: "add the owner/GC filter to
// the schedule page too"). A row's answer is the server's row.ownerSignOff
// (utils/ownerSignOff.decorateActivities): signed off - the starred row and
// every row under it alike - planned when its day is still ahead, else not.
// The same three answers as the issue and shop drawing filters.
export const ownerStateOfItem = (it) => {
  const o = it && it.ownerSignOff;
  return !o ? "not" : o.planned ? "planned" : "signed";
};
